import React, { useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import Button from "../../Component/Button/Button";
import { useForm } from "react-hook-form";
import requestS from "./CooperationRequest.module.css";
import { errorToast, succToast } from "../../Toast/Toast";
import { CooperationRequestApi } from "../../Api/BarestServices";
import { useHistory } from "react-router";

const CooperationRequest = (props) => {
  const history = useHistory();
  const [disable, setDisable] = useState(false);
  const [type, setType] = useState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    setDisable(true);
    if (data.job === "0") {
      errorToast("نوع کسب کارمشخص کنید");
    } else if (data.city === "0") {
      errorToast("شهر کسب کار خودرامشخص کنید");
    } else {
      let info = {
        business_name: data.placename,
        business_owner_first_name: data.sahebname,
        business_owner_last_name: data.saheblastname,
        phone: data.phone,
        type: data.job,
        city_id: data.city,
        market_type: data.marketType,
      };
      CooperationRequestApi(info, (res) => {
        if (res.status === 1) {
          succToast(res.message);
          setTimeout(() => history.push("/"), 1000);
          setDisable(false);
        } else {
          errorToast(res.message);
          setDisable(false);
        }
      });
    }
  };
  return (
    <div className={requestS.pageHolder}>
      <BurgerMenuTitle title="درخواست همکاری" />
      <div className={requestS.imageHolder}>
        <img
          src="/Assets/Images/cooperationRequest/cooperationRequest.png"
          alt="درخواست همکاری"
        />
      </div>
      <div className={requestS.selectHolder}>
        <select
          {...register("job")}
          onChange={(e) => setType(e.target.value)}
          className={requestS.eachSelect}
        >
          <option value={0}>انتخاب نوع کسب و کار</option>
          <option value={"food"}>رستوران</option>
          <option value={"supermarket"}>فروشگاه</option>
        </select>
        <select {...register("city")} className={requestS.eachSelect}>
          <option value={0}> انتخاب شهر</option>
          <option value={"4851"}>بهشهر</option>
          <option value={"4841"}>نکا</option>
          <option value={"4861"}>گلوگاه</option>
        </select>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className={requestS.formHandel}>
        <div className={requestS.inputHolder}>
          <input
            {...register("placename", { required: true })}
            placeholder={"نام فروشگاه یا رستوران"}
            className={errors.placename ? requestS.valid : requestS.text}
          />

          <input
            {...register("sahebname", { required: true })}
            placeholder={"نام مالک فروشگاه یا رستوران"}
            className={errors.sahebname ? requestS.valid : requestS.text}
          />
          {type === "supermarket" ? (
            <input
              {...register("marketType", { required: true })}
              placeholder={"نوع فروشگاه"}
              className={errors.sahebname ? requestS.valid : requestS.text}
            />
          ) : null}

          <input
            {...register("saheblastname", { required: true })}
            placeholder={"نام خانوادگی مالک فروشگاه یا رستوران"}
            className={errors.saheblastname ? requestS.valid : requestS.text}
          />

          <input
            {...register("phone", { required: true })}
            placeholder={"تلفن همراه"}
            type="tel"
            maxLength="11"
            className={errors.phone ? requestS.valid : requestS.text}
          />
        </div>
        <div className={requestS.buttonHolder}>
          {/* <Button
            type={"submit"}
            className={requestS.btnResponsive}
            ClassBtn={"confrimBtn"}
            Value="ارسال"
            disabledprops={disable}
          /> */}
          <button className={requestS.btnResponsive} disabled={disable}>
            ارسال
          </button>
        </div>
      </form>
    </div>
  );
};

export default CooperationRequest;
